import { CreditRslaWorksheet, EditCreditRslaWorksheetDto } from '@src/data/types/CreditRslaWorksheet'
import { makeCreate, makeGetSingleFromApi, makeUpdate } from '../make-api'

const baseUrl = '/Applications/credit-rsla/{creditApplicationId}/Worksheet'
const creditRslaWorksheetApi = {
  getById: makeGetSingleFromApi<CreditRslaWorksheet>(baseUrl),
  create: makeCreate<EditCreditRslaWorksheetDto, CreditRslaWorksheet>(baseUrl),
  update: makeUpdate<EditCreditRslaWorksheetDto, CreditRslaWorksheet>(baseUrl),
}

export default creditRslaWorksheetApi
